import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import validate from './validation'
import * as ContentActions from '../../../../actions/content'
import { ChannelsForm } from '../../../../components/Screens'
import { ContentTypes } from '../../../../constants'
import { playlistsForm as playlistsFormProps } from '../../../../types'
import { ObjectUtils } from '../../../../utils'

class Channels extends PureComponent {
    static propTypes = {
        editFormValue: PropTypes.func.isRequired,
        form: PropTypes.shape(playlistsFormProps).isRequired,
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool.isRequired,
        onClickCancel: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        createChannel: PropTypes.func.isRequired,
        updateChannel: PropTypes.func.isRequired,
        resetUpload: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
        isOpenForEdit: PropTypes.bool,
        channelId: PropTypes.number,
        initialChannel: PropTypes.shape({ name: PropTypes.string, slug: PropTypes.string, channel_extra: PropTypes.string }),
    }

    static defaultProps = {
        isOpen: false,
        isOpenForEdit: false,
        onClickCancel: () => null,
        onFinishSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            formErrors: {
                name: null,
                date_start: null,
                date_end: null,
                slug: null,
                synced: null,
                chain_id: null,
            },
        }

        this.onChangeFormValue = this.onChangeFormValue.bind(this)
        this.onChangeSynced = this.onChangeSynced.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onFinishSubmitChannels = this.onFinishSubmitChannels.bind(this)
        this.inputToFocus = React.createRef()
    }

    componentDidUpdate(lastProps) {
        const { isOpen } = this.props
        const { isOpen: wasOpen } = lastProps

        if (isOpen && !wasOpen) {
            this.inputToFocus.current.focus()
        }
    }

    onChangeFormValue({ target: { name, value } }) {
        console.log(name, typeof value, value)
        const { editFormValue } = this.props
        if (name === 'name') {
            const slugValue = value.replace(/ /g, '_').toLowerCase()
            editFormValue(ContentTypes.CHANNELS, { name: 'slug', value: slugValue })
        }
        editFormValue(ContentTypes.CHANNELS, { name, value })
    }

    onChangeChainId = (chainValue) => {
        const { editFormValue } = this.props;
        editFormValue(ContentTypes.CHANNELS, { name: 'chain_id', value: chainValue });
    }

    onChangeSynced() {
        const {
            editFormValue,
            form: { synced },
        } = this.props
        const value = synced ? 0 : 1
        editFormValue(ContentTypes.CHANNELS, { name: 'synced', value })
    }

    async onSubmit() {
        if (!this.validate()) {
            return
        }

        const { form, isOpenForEdit, onFinishSubmit, createChannel, resetUpload, channelId, updateChannel } = this.props
        const action = isOpenForEdit ? await updateChannel(channelId, form) : await createChannel(form)
        await onFinishSubmit(action)
        await resetUpload(ContentTypes.CHANNELS)
    }

    buildOnchangeObject() {
        return {
            name: this.onChangeFormValue,
            date_start: (value) => this.onChangeFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangeFormValue({ target: { name: 'date_end', value } }),
            slug: this.onChangeFormValue,
            channel_extra: this.onChangeFormValue,
            synced: this.onChangeSynced,
            chain_id: this.onChangeChainId,
        }
    }

    /**
     * Once all the new channel has been stored, we attach it to the playlist
     * @param {Array} storedActionsArray Redux action from upload
     * @async
     */
    async onFinishSubmitChannels(storedAction) {
        const {
            payload: { id: channelID, name: searchChannel },
        } = storedAction
        this.setState({ isFormChannelsOpen: false, searchChannel }, () => this.onChangeChannel(channelID))
    }

    /**
     * Form Validation
     */
    validate() {
        const { form } = this.props
        const formErrors = validate(form)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    render() {
        const { form, initialChannel, isOpen, isOpenForEdit, isWorking, onClickCancel, t } = this.props
        const { formErrors } = this.state
        return (
            <ChannelsForm
                isOpenForEdit={isOpenForEdit}
                ref={this.inputToFocus}
                errors={formErrors}
                isOpen={isOpen}
                isWorking={isWorking}
                onChangeForm={this.buildOnchangeObject()}
                onClickCancel={onClickCancel}
                onFinishSubmit={this.onFinishSubmitChannels}
                onClickSubmit={this.onSubmit}
                values={form}
                initialChannel={initialChannel}
                t={t}
                updateValues={() => {
                    const { isOpenForEdit, form, initialChannel } = this.props
                    if (isOpenForEdit) {
                        form.name = initialChannel.name
                        form.slug = initialChannel.slug
                        if (initialChannel.channel_extra) form.channel_extra = initialChannel.channel_extra
                    }
                }}
            />
        )
    }
}

const mapStateToProps = ({
    content: {
        isWorking: { channels: isWorking },
        form: { channels: form },
    },
}) => ({
    form,
    isWorking,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Channels))
